var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgQuicker = function SvgQuicker(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 12 16",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5H6.625L7.969.969C8.094.469 7.719 0 7.25 0h-4.5c-.375 0-.719.281-.75.656l-1 7.5c-.063.469.281.844.75.844h3.688L4 15.094c-.094.469.25.906.719.906.281 0 .531-.125.656-.375l5.5-9.5C11.188 5.656 10.812 5 10.25 5Z"
  })));
};
export { SvgQuicker as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMC4yNSA1SDYuNjI1TDcuOTY4NzUgMC45Njg3NUM4LjA5Mzc1IDAuNDY4NzUgNy43MTg3NSAwIDcuMjUgMEgyLjc1QzIuMzc1IDAgMi4wMzEyNSAwLjI4MTI1IDIgMC42NTYyNUwxIDguMTU2MjVDMC45Mzc1IDguNjI1IDEuMjgxMjUgOSAxLjc1IDlINS40Mzc1TDQgMTUuMDkzOEMzLjkwNjI1IDE1LjU2MjUgNC4yNSAxNiA0LjcxODc1IDE2QzUgMTYgNS4yNSAxNS44NzUgNS4zNzUgMTUuNjI1TDEwLjg3NSA2LjEyNUMxMS4xODc1IDUuNjU2MjUgMTAuODEyNSA1IDEwLjI1IDVaIiAvPgo8L3N2Zz4K";